import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  CardMedia,
  Dialog,
  Tooltip,
  Theme,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import {
  applicationDownloadStatusCheck,
  checkIfApplicationIsNonIndividual,
  currencyConversion,
  getFirstHolderName,
  handleDownload,
} from '../../utils/utilityFunctions';
import { ConfirmationDialog, LoadingDialog } from '../commonComponents';
import LiveRegion from '../LiveRegion';
import React, { useEffect, useState } from 'react';
import { getAllApplications, getApplicationDetails } from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import {
  ApplicationProps,
  investmentDetailsAplicationRef,
} from '../../redux-store/types/api-types';
import { ColumnType, DataTable } from '../DataTable';
import {
  APPLICATION_LISTING_STATUS,
  POA_APPLICATION_STATUS,
  REJECTED_ROLES,
  USER_ROLES,
} from '../../utils/constant';
import { formatShortDate, formatShortDateAndTime } from '../../utils/date';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ApplicationDownload, ApplicationRefs } from '../../redux-store/actions/onBoarding';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import { RootStateType } from '../../redux-store/reducers';
import { SxProps } from '@mui/system';
import { useSnackbar } from 'notistack';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { reportDownload } from '../Reports/report-utils';
import { LoadingButton } from '@mui/lab';
import { changeStatusToDraft } from '../../redux-store/actions/adminSupport';

export const getTableHeader = (): ColumnType[] => {
  return [
    {
      header: 'Application Number',
      label: 'applicationNumber',
      valueGetter: (row: ApplicationProps) => row.applicationNumber || 'N/A',
    },
    {
      header: 'Investor Name',
      valueGetter: ({ applicants = [] }: ApplicationProps) =>
        getFirstHolderName(applicants) || 'N/A',
    },
    // {
    //   header: 'Mode of Holding',
    //   renderCell: (row: ApplicationProps) => {
    //     return (
    //       <Typography
    //         sx={{
    //           textTransform: 'capitalize',
    //         }}>
    //         {(row.modeOfHolding === 'either or survivor' ? 'Joint' : row.modeOfHolding) || 'Single'}
    //       </Typography>
    //     );
    //   },
    // },
    {
      header: 'Investor PAN',
      valueGetter: ({ applicants = [] }: ApplicationProps) => applicants[0]?.panNo || 'N/A',
    },
    {
      header: 'Distributor Name',
      label: 'viewDistributorRM',
      valueGetter: (row: ApplicationProps) =>
        row.distributor?.name || row.distributor?.arnCode || 'N/A',
    },
    // {
    //   header: 'Filled By',
    //   label: 'filledBy',
    //   valueGetter: (row: ApplicationProps) => row.filledBy || 'N/A',
    // },
    // {
    //   header: 'AMC RM Name',
    //   valueGetter: (row: ApplicationProps) => row.rm?.name || 'N/A',
    // },
    {
      header: 'Filled By',
      label: 'filledBy',
      valueGetter: (row: ApplicationProps) => row.supportSubdistributor?.user?.firstName || 'N/A',
    },
    {
      header: 'Distributor RM Name',
      valueGetter: (row: ApplicationProps) => row?.subDistributor?.user?.firstName || 'N/A',
    },
    {
      header: 'Commitment Amount',
      renderCell: (row: ApplicationProps) => {
        return (
          <Typography style={{ fontSize: 'inherit', maxWidth: 210 }}>
            {row.commitmentAmount || 'N/A'}
            <Typography style={{ fontSize: 12 }}>
              {currencyConversion(row.commitmentAmount)}
            </Typography>
          </Typography>
        );
      },
    },
    {
      header: 'Status',
      renderCell: (row: ApplicationProps) => <StatusPill status={row.status} />,
    },
  ];
};

const getStatusPillStyles = (status: string) => {
  const label = APPLICATION_LISTING_STATUS[status] || status;

  if (['completed', 'signed'].includes(status)) {
    return { label: 'Completed', bg: '#ECFDF5', color: '#059669' };
  }
  if (status === 'rejected' || status === 'invitationexpired') {
    return {
      label,
      bg: '#FEE4E2',
      color: '#B42318',
    };
  }
  if (status === 'draft' || status === 'draft_send_back') {
    return { label: status === 'draft_send_back' ? label : 'Draft', bg: '#F3F4F6', color: '#6B7280' };
  }
  if (status === 'sent_to_applicant1') {
    return { label, bg: '#FCE7F3', color: '#BE185D' };
  }
  if (
    [
      'approved_by_applicant1',
      'approved_by_applicant2',
      'approved_by_applicant3',
      'approved_by_fundmanager',
      'approved_by_trustee',
    ].includes(status)
  ) {
    return { label, bg: '#F3E8FF', color: '#7C3AED' };
  }
  if (['sent_to_poa_approver', 'sent_to_amc_approver'].includes(status)) {
    return { label, bg: '#FFF7ED', color: '#D97706' };
  }
  if ([ 'sent_to_authorised_signatories','approved_by_authorised_signatories'].includes(status)) {
    return { label, bg: '#EEF2FF', color: '#4F46E5' };
  }
  return {
    label,
    bg: '#EEF2FF',
    color: '#4F46E5',
  };
};

const StatusPill = ({ status }: { status: string }): JSX.Element => {
  const pill = getStatusPillStyles(status);
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 1.5,
        py: 0.5,
        borderRadius: '9999px',
        background: pill.bg,
        color: pill.color,
        fontFamily: 'Inter, sans-serif',
        fontSize: 12,
        fontWeight: 500,
        fontStyle: 'normal',
        lineHeight: 1.3,
        letterSpacing: 0,
        whiteSpace: 'nowrap',
        maxWidth: 'fit-content',
      }}>
      {pill.label}
    </Box>
  );
};

export const getDashboardTableHeader = (): ColumnType[] => {
  return [
    {
      header: 'Application Number',
      label: 'applicationNumber',
      minWidth: 120,
      valueGetter: (row: ApplicationProps) => row.applicationNumber || 'N/A',
    },
    {
      header: 'First Holder Name',
      align: 'left',
      headerAlign: 'left',
      minWidth: 140,
      renderCell: ({ applicants = [] }: ApplicationProps) => (
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: 14,
            color: 'inherit',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            lineHeight: 1.3,
            textAlign: 'left',
          }}>
          {getFirstHolderName(applicants) || 'N/A'}
        </Typography>
      ),
    },
    {
      header: 'Mode of Holding',
      minWidth: 120,
      valueGetter: (row: ApplicationProps) =>
        (row.modeOfHolding === 'either or survivor' ? 'Joint' : row.modeOfHolding) || 'Single',
    },
    {
      header: 'Committed Value',
      minWidth: 120,
      renderCell: (row: ApplicationProps) => (
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: 14,
            color: 'inherit',
            whiteSpace: 'nowrap',
            display: 'inline-block',
          }}>
          {row.commitmentAmount != null
            ? Number(row.commitmentAmount).toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : 'N/A'}
        </Typography>
      ),
    },
    {
      header: 'First Holder PAN',
      minWidth: 120,
      renderCell: ({ applicants = [] }: ApplicationProps) => (
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: 14,
            color: 'inherit',
            whiteSpace: 'nowrap',
            display: 'inline-block',
          }}>
          {applicants[0]?.panNo || 'N/A'}
        </Typography>
      ),
    },
    {
      header: 'Start Date',
      minWidth: 120,
      valueGetter: (row: ApplicationProps) => formatShortDate(row.createdAt) || 'N/A',
    },
    {
      header: 'Distributor Name',
      align: 'left',
      headerAlign: 'left',
      minWidth: 120,
      valueGetter: (row: ApplicationProps) =>
        row.distributor?.name || row.distributor?.arnCode || 'N/A',
    },
    {
      header: 'Status',
      minWidth: 120,
      renderCell: (row: ApplicationProps) => <StatusPill status={row.status} />,
    },
  ];
};

export default function DashboardAndApplicationsList({
  isLoading,
  applicationsList,
  boxStyles,
  DashboardApplicationsList,
}: {
  isLoading: boolean;
  applicationsList: ApplicationProps[];
  boxStyles?: SxProps<Theme>;
  DashboardApplicationsList?: boolean;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();

  const [rejectionDialog, setRejectionDialog] = useState(false);

  const [rejectedApplication, setRejectedApplication] = useState<ApplicationProps>();
  const [isDialogLoading, setDialogLoading] = useState(false);
  const [id, setId] = useState('');
  const [checkPoaOrNI, setCheckPoaOrNI] = useState(false);
  const [tooltip, setTooltip] = useState('Click to Copy');
  const [copyStatusMessage, setCopyStatusMessage] = useState('');
  const [applicationRefsList, setApplicationRefsList] = useState<investmentDetailsAplicationRef[]>(
    []
  );
  const [open, setOpen] = useState(false);
  const [draftLoading, setDraftLoading] = useState('');
  const [deletePopUp, setDeletePopUp] = useState<{ id: string } | null>(null);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [applicationsListData, setApplicationsListData] = useState<ApplicationProps[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
  } = useSelector((store: RootStateType) => store.paramsObj);

  const handleClose = () => {
    setOpen(false);
    setId('');
    setCopyStatusMessage('');
  };
  const handleDialogClose = () => {
    setDialogLoading(false);
    setOpen(true);
  };

  const handleRejectionDialogClose = () => {
    setRejectionDialog(false);
  };
  useEffect(() => {
    setApplicationsListData(applicationsList);
  }, [applicationsList]);

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        if (id) {
          const responseApplicationRefsList = (await dispatch(
            ApplicationRefs(id)
          )) as unknown as investmentDetailsAplicationRef[];
          if (!componentIsAlive) {
            return;
          }
          setApplicationRefsList(responseApplicationRefsList);
          handleDialogClose();
        }
      } catch (e) {
        setDialogLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [id]);

  const additionalCell = {
    header: '',
    renderEditDeleteCell: (row: ApplicationProps): JSX.Element => {
      const [loadingPopup, setLoadingPopup] = useState(false);
      const [downloadPopup, setDownloadPopup] = useState(false);

      const handleDownloadPopupClose = () => {
        setDownloadPopup(false);
      };

      const handleLoadingPopupClose = () => {
        setLoadingPopup(false);
      };
      return (
        <Box display="flex">
          {APPLICATION_LISTING_STATUS[row.status] === APPLICATION_LISTING_STATUS.rejected && (
            <IconButton
              aria-label="View rejection reason"
              onClick={() => {
                setRejectedApplication(row);
                setRejectionDialog(true);
              }}>
              <CardMedia
                component="img"
                src="/images/comment.svg"
                alt=""
                aria-hidden="true"
                sx={{ width: '20px' }}
              />
            </IconButton>
          )}
          {!['draft', 'rejected', 'sent_to_poa_approver', 'sent_to_amc_approver'].includes(
            row.status
          ) && (
            <Tooltip title="Link">
              <IconButton
                aria-label={`Open signature links for application ${row.applicationNumber || ''}`}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}
                onClick={() => {
                  setId(row.id as string),
                    setDialogLoading(true),
                    setCheckPoaOrNI(row.hasPOA || checkIfApplicationIsNonIndividual(row));
                }}>
                <CardMedia
                  component="img"
                  src="/images/link-icon.svg"
                  alt=""
                  aria-hidden="true"
                  sx={{ width: '30px' }}
                />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title={row.editable ? 'Edit' : ''}>
            <IconButton
              role="link"
              aria-label={
                row.editable
                  ? `Edit, ${row.applicationNumber || ''}`
                  : `Edit unavailable, ${row.applicationNumber || ''}`
              }
              onClick={() => {
                row.editable &&
                  history.push(
                    checkIfApplicationIsNonIndividual(row)
                      ? `/non-individual-application`
                      : `/application`,
                    { id: row.id }
                  );
              }}
              sx={{
                ':hover': {
                  bgcolor: '#F4FCFC',
                },
                '&.Mui-disabled': {
                  cursor: row.editable ? 'pointer' : 'not-allowed !important',
                  pointerEvents: 'all',
                },
              }}
              disabled={!row.editable}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          {[USER_ROLES.AMC_ADMIN].includes(role) && (
            <Tooltip title={row.deletable ? 'Delete' : 'Application can`t be Deleted'}>
              <IconButton
                aria-label={row.deletable ? 'Delete application' : 'Delete unavailable'}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                  '&.Mui-disabled': {
                    cursor: row.deletable ? 'pointer' : 'not-allowed !important',
                    pointerEvents: 'all',
                  },
                }}
                onClick={() => row.deletable && setDeletePopUp({ id: row.id })}
                disabled={!row.deletable}>
                <DeleteOutlineIcon color={row.deletable ? 'error' : 'disabled'} fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={
              applicationDownloadStatusCheck(row.status || '') || row?.signedLeegalityFile?.url
                ? 'Download'
                : 'Only Signed Documents can be Downloaded'
            }>
            <IconButton
              aria-label={
                applicationDownloadStatusCheck(row.status || '') || row?.signedLeegalityFile?.url
                  ? `Download document for application ${row.applicationNumber || ''}`
                  : 'Download unavailable'
              }
              sx={{
                ':hover': {
                  bgcolor: '#F4FCFC',
                },
                cursor: 'pointer',
                pointerEvents: 'all',
              }}
              onClick={async () => {
                try {
                  if (applicationDownloadStatusCheck(row.status || '')) {
                    setDownloadPopup(true);
                    const res = (await dispatch(ApplicationDownload(row.id))) as unknown as any;
                    reportDownload(res as unknown as Blob, `${row.applicationNumber}.pdf`);
                    setDownloadPopup(false);
                    return;
                  }
                  // row?.signedLeegalityFile?.url && window.open(row?.signedLeegalityFile?.url);
                  row?.signedLeegalityFile?.url &&
                    (await handleDownload(
                      row?.signedLeegalityFile?.url as string,
                      `${row.applicationNumber}.pdf`
                    ));
                } catch (e) {
                  setDownloadPopup(false);
                  console.error((e as Error).message);
                }
              }}>
              <CardMedia
                component="img"
                src={
                  applicationDownloadStatusCheck(row.status || '') || row?.signedLeegalityFile?.url
                    ? '/images/download-icon.png'
                    : '/images/download-icon-disabled.png'
                }
                alt=""
                aria-hidden="true"
                //sx={{ width: '30px' }}
              />
            </IconButton>
          </Tooltip>
          {[
            APPLICATION_LISTING_STATUS.sent_to_applicant1,
            APPLICATION_LISTING_STATUS.sent_to_authorised_signatories,
          ].includes(APPLICATION_LISTING_STATUS[row.status]) &&
            [USER_ROLES.AMC_ADMIN, USER_ROLES.RM].includes(role) && (
              <LoadingButton
                loadingPosition="start"
                variant="contained"
                sx={{
                  color: 'common.white',
                  lineHeight: '14px',
                  fontSize: 10,
                  width: 80,
                  ml: 1,
                }}
                loading={draftLoading === row?.applicationNumber}
                onClick={async () => {
                  setDraftLoading(row.applicationNumber);
                  try {
                    await dispatch(
                      changeStatusToDraft({
                        applicationNumber: row.applicationNumber,
                        deleteLeegalityDocument: true,
                      })
                    );
                    setDraftLoading('');
                    if (DashboardApplicationsList) {
                      setDialogLoading(true);
                      const response = (await dispatch(
                        getAllApplications({
                          page: 1,
                          limit: 4,
                        })
                      )) as unknown as GetAllApplicantionsResponseBody;
                      const { applications } = response || {};
                      setApplicationsListData(applications);
                      setDialogLoading(false);
                    } else {
                      setDialogLoading(true);
                      const applicationResponse = (await dispatch(
                        getAllApplications({
                          page,
                          search: storeSearch,
                          status: storeStatus,
                          applicationType: storeApplicationType,
                          modeOfHolding: storeModeOfHolding,
                          distributorId: storeDistributorId,
                        })
                      )) as unknown as GetAllApplicantionsResponseBody;
                      const { applications } = applicationResponse || {};
                      setApplicationsListData(applications);
                      setDialogLoading(false);
                    }
                  } catch (e) {
                    setDraftLoading('');
                    setDialogLoading(false);
                    console.error((e as Error).message);
                  }
                }}>
                Move to Draft
              </LoadingButton>
            )}
          <LoadingDialog
            loadingPopup={loadingPopup}
            onLoadingPopupClose={handleLoadingPopupClose}
            loaderText={'Loading'}
          />
          <LoadingDialog
            loadingPopup={downloadPopup}
            onLoadingPopupClose={handleDownloadPopupClose}
            loaderText={'Downloading'}
          />
        </Box>
      );
    },
  };

  const dashboardActionsCell = {
    header: 'Actions',
    renderEditDeleteCell: (row: ApplicationProps): JSX.Element => {
      const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
      const [downloadPopup, setDownloadPopup] = useState(false);
      const menuOpen = Boolean(anchorEl);
      const canOpenLink = ![
        'draft',
        'rejected',
        'sent_to_poa_approver',
        'sent_to_amc_approver',
      ].includes(row.status);
      const canDownload =
        applicationDownloadStatusCheck(row.status || '') || !!row?.signedLeegalityFile?.url;
      const canViewRejection =
        APPLICATION_LISTING_STATUS[row.status] === APPLICATION_LISTING_STATUS.rejected;
      const canMoveToDraft =
        [
          APPLICATION_LISTING_STATUS.sent_to_applicant1,
          APPLICATION_LISTING_STATUS.sent_to_authorised_signatories,
        ].includes(APPLICATION_LISTING_STATUS[row.status]) &&
        [USER_ROLES.AMC_ADMIN, USER_ROLES.RM].includes(role);
      const isDraftLoading = draftLoading === row?.applicationNumber;

      const handleCloseMenu = () => setAnchorEl(null);

      const openGetLinkPopup = () => {
        handleCloseMenu();
        setId(row.id as string);
        setDialogLoading(true);
        setCheckPoaOrNI(row.hasPOA || checkIfApplicationIsNonIndividual(row));
      };

      const onDownloadSignedFile = async () => {
        handleCloseMenu();
        try {
          if (applicationDownloadStatusCheck(row.status || '')) {
            setDownloadPopup(true);
            const res = (await dispatch(ApplicationDownload(row.id))) as unknown as any;
            reportDownload(res as unknown as Blob, `${row.applicationNumber}.pdf`);
            setDownloadPopup(false);
            return;
          }
          if (row?.signedLeegalityFile?.url) {
            await handleDownload(
              row.signedLeegalityFile.url as string,
              `${row.applicationNumber}.pdf`
            );
          }
        } catch (e) {
          setDownloadPopup(false);
          console.error((e as Error).message);
        }
      };

      const onMoveToDraft = async () => {
        handleCloseMenu();
        setDraftLoading(row.applicationNumber);
        try {
          await dispatch(
            changeStatusToDraft({
              applicationNumber: row.applicationNumber,
              deleteLeegalityDocument: true,
            })
          );
          setDraftLoading('');
          setDialogLoading(true);
          if (DashboardApplicationsList) {
            const response = (await dispatch(
              getAllApplications({
                page: 1,
                limit: 4,
              })
            )) as unknown as GetAllApplicantionsResponseBody;
            const { applications } = response || {};
            setApplicationsListData(applications);
          } else {
            const applicationResponse = (await dispatch(
              getAllApplications({
                page,
                search: storeSearch,
                status: storeStatus,
                applicationType: storeApplicationType,
                modeOfHolding: storeModeOfHolding,
                distributorId: storeDistributorId,
              })
            )) as unknown as GetAllApplicantionsResponseBody;
            const { applications } = applicationResponse || {};
            setApplicationsListData(applications);
          }
          setDialogLoading(false);
        } catch (e) {
          setDraftLoading('');
          setDialogLoading(false);
          console.error((e as Error).message);
        }
      };

      const menuItemSx = {
        minHeight: '20px',
        height: '20px',
        padding: 0,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',

        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '16px',
        color: '#585E6B',

        '& .MuiListItemIcon-root': {
          minWidth: '20px',
          width: '20px',
          height: '20px',
          margin: 0,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#2057A6',

          '& svg': {
            width: '20px',
            height: '20px',
            color: '#2057A6',
          },
        },

        '& .MuiListItemText-root': {
          margin: 0,
          padding: 0,
        },

        '& .MuiListItemText-primary': {
          fontFamily: 'Roboto, sans-serif',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '16px',
          color: '#585E6B',
          whiteSpace: 'nowrap',
        },

        '&:hover': {
          backgroundColor: 'transparent',
        },
      };

      return (
        <>
          <IconButton
            aria-label={`Open actions for ${row.applicationNumber || ''}`}
            aria-controls={menuOpen ? `actions-menu-${row.id}` : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{ color: '#2057A6' }}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            id={`actions-menu-${row.id}`}
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleCloseMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                width: '234px',
                minWidth: '234px',
                maxWidth: '234px',
                borderRadius: '14px',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 9px 40px rgba(0, 0, 0, 0.104977)',
                padding: '16px',
                boxSizing: 'border-box',
                '& .MuiList-root': {
                  padding: 0,
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                },
              },
            }}>
            <MenuItem
              sx={menuItemSx}
              onClick={() => {
                handleCloseMenu();
                history.push(
                  checkIfApplicationIsNonIndividual(row)
                    ? `/non-individual-application-details/${row.id}`
                    : `/application-details/${row.id}`
                );
              }}>
              <ListItemIcon>
                <VisibilityOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="View Details" />
            </MenuItem>
            {canViewRejection && (
              <>
                <Divider
                  sx={{
                    width: '100%',
                    height: 0,
                    margin: 0,
                    border: 0,
                    borderTop: '0.5px dashed #CDCDCD',
                  }}
                />
                <MenuItem
                  sx={menuItemSx}
                  onClick={() => {
                    handleCloseMenu();
                    setRejectedApplication(row);
                    setRejectionDialog(true);
                  }}>
                  <ListItemIcon>
                    <CommentOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="View Rejection Reason" />
                </MenuItem>
              </>
            )}
            {canOpenLink && (
              <>
                <Divider sx={{ borderStyle: 'dashed', my: 0.5 }} />
                <MenuItem sx={menuItemSx} onClick={openGetLinkPopup}>
                  <ListItemIcon>
                    <ContentCopyOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Get Link" />
                </MenuItem>
              </>
            )}
            <Divider sx={{ borderStyle: 'dashed', my: 0.5 }} />
            <MenuItem
              sx={{ ...menuItemSx, color: row.editable ? '#344054' : '#98A2B3' }}
              disabled={!row.editable}
              onClick={() => {
                handleCloseMenu();
                if (!row.editable) return;
                history.push(
                  checkIfApplicationIsNonIndividual(row)
                    ? `/non-individual-application`
                    : `/application`,
                  { id: row.id }
                );
              }}>
              <ListItemIcon>
                <EditIcon fontSize="small" color={row.editable ? 'inherit' : 'disabled'} />
              </ListItemIcon>
              <ListItemText primary="Edit" />
            </MenuItem>
            <Divider sx={{ borderStyle: 'dashed', my: 0.5 }} />
            <MenuItem sx={menuItemSx} onClick={onDownloadSignedFile} disabled={!canDownload}>
              <ListItemIcon>
                <FileDownloadOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Download Signed File" />
            </MenuItem>
            {canMoveToDraft && (
              <>
                <Divider sx={{ borderStyle: 'dashed', my: 0.5 }} />
                <MenuItem sx={menuItemSx} onClick={onMoveToDraft} disabled={isDraftLoading}>
                  <ListItemIcon>
                    <DraftsOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={isDraftLoading ? 'Moving to Draft...' : 'Move to Draft'} />
                </MenuItem>
              </>
            )}
            {[USER_ROLES.AMC_ADMIN].includes(role) && (
              <>
                <Divider sx={{ borderStyle: 'dashed', my: 0.5 }} />
                <MenuItem
                  sx={{ ...menuItemSx, color: row.deletable ? '#B42318' : '#98A2B3' }}
                  disabled={!row.deletable}
                  onClick={() => {
                    handleCloseMenu();
                    if (row.deletable) {
                      setDeletePopUp({ id: row.id });
                    }
                  }}>
                  <ListItemIcon>
                    <DeleteOutlineIcon
                      fontSize="small"
                      color={row.deletable ? 'error' : 'disabled'}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Delete" />
                </MenuItem>
              </>
            )}
          </Menu>
          <LoadingDialog
            loadingPopup={downloadPopup}
            onLoadingPopupClose={() => setDownloadPopup(false)}
            loaderText={'Downloading'}
          />
        </>
      );
    },
  };

  return (
    <>
      <LiveRegion message={copyStatusMessage} />
      <Box sx={{ width: '100%', overflowX: 'auto', minWidth: 0 }}>
        <DataTable
          isLoading={isLoading}
          tableHeader={
            DashboardApplicationsList
              ? [...getDashboardTableHeader(), dashboardActionsCell]
              : [...getTableHeader(), dashboardActionsCell]
          }
          tableData={applicationsListData}
          tableHeaderCustomStyles={{
            '.MuiTableCell-head': {
              fontFamily: 'Roboto, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              color: '#1F53BE',
              backgroundColor: '#F6F9FD',
              whiteSpace: 'normal',
              wordBreak: 'normal',
              lineHeight: 1.3,
              borderBottom: '1px solid #F2F4F7',
            },
          }}
          rowCustomStyles={{
            '&:last-child td, &:last-child th': { border: 0 },
            '.MuiTableCell-body ': {
              color: '#111927',
              fontFamily: 'Roboto, sans-serif',
              fontSize: 14,
              borderBottom: '1px solid #F2F4F7',
              wordBreak: 'normal',
              px: 1,
            },
            background: 'transparent',
          }}
          boxStyles={{
            ...boxStyles,
            minWidth: 0,
            width: '100%',
            overflowX: 'auto',
          }}
        />
      </Box>

      <Dialog
        onClose={handleClose}
        open={open}
        PaperProps={{
          'aria-label': 'Get Link',
        }}
        sx={{
          '.MuiPaper-root ': {
            width: { xs: '70%', sm: '70%' },
          },
        }}>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          p={4}
          pb={2}>
          <Typography
            component="h2"
            sx={{ color: 'primary.main', fontSize: '20px', fontWeight: 500 }}>
            Get Link
          </Typography>
          <IconButton aria-label="Close dialog" onClick={handleClose}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Grid>
        {applicationRefsList &&
          applicationRefsList.map((ref) => {
            return (
              <React.Fragment key={ref.id}>
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  px={4}
                  py={1}
                  sx={{
                    ':hover': {
                      bgcolor: '#F4FCFC',
                    },
                    ':last-of-type': {
                      mb: 5,
                    },
                  }}>
                  <Typography
                    sx={{
                      color: 'rgba(41, 49, 57, 0.7)',
                      fontSize: '18px',
                      fontWeight: 500,
                    }}>
                    Copy Link For {ref.name}
                  </Typography>
                  <Tooltip title={tooltip}>
                    <IconButton
                      aria-label={`Copy link for ${ref.name}`}
                      onMouseOver={() => {
                        setTooltip('Copy Link');
                      }}
                      onClick={() => {
                        setTooltip('Copied');
                        navigator.clipboard.writeText(
                          checkPoaOrNI
                            ? ref.invitationUrl
                            : ref?.signatureBy &&
                              ('fundManager' === ref.signatureBy ||
                                USER_ROLES.TRUSTEE === ref.signatureBy)
                            ? ref.invitationUrl
                            : `${window.location.origin}/investment-details/${ref.referenceId}/application-details`
                        );
                        setCopyStatusMessage('');
                        window.setTimeout(() => {
                          setCopyStatusMessage('Copied');
                        }, 50);
                      }}>
                      <CardMedia
                        component="img"
                        src="/images/link-icon.svg"
                        alt=""
                        aria-hidden="true"
                        sx={{ width: '35px' }}
                      />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </React.Fragment>
            );
          })}
      </Dialog>
      <LoadingDialog
        loadingPopup={isDialogLoading}
        onLoadingPopupClose={handleDialogClose}
        loaderText="Loading"
      />
      <Dialog
        onClose={handleRejectionDialogClose}
        open={rejectionDialog}
        sx={{
          '.MuiPaper-root ': {
            width: { xs: '70%', sm: '70%' },
          },
        }}>
        <IconButton
          aria-label="Close rejection details dialog"
          onClick={handleRejectionDialogClose}
          sx={{ alignSelf: 'flex-end', mt: 2, mr: 2 }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        {rejectedApplication && (
          <Box
            sx={{
              width: { xs: '80%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontWeight: 500,
              },
              mt: 1,
              mb: 5,
            }}>
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: '18px',
                letterSpacing: '0.4px',
                ml: { sm: 6.7 },
                mt: 1,
              }}>
              Application Id:{' '}
              <Typography
                component="span"
                sx={{
                  color: '#337FC9',
                  fontSize: '16px',
                  letterSpacing: '0.4px',
                  ml: 0.5,
                }}>
                {rejectedApplication.applicationNumber}
              </Typography>
            </Typography>
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: '18px',
                letterSpacing: '0.4px',
                ml: { sm: 1.5 },
                mt: 1,
              }}>
              Application Status:{' '}
              <Typography
                component="span"
                sx={{
                  color: '#BD2932',
                  fontSize: '16px',
                  letterSpacing: '0.4px',
                  ml: 0.5,
                }}>
                {POA_APPLICATION_STATUS[rejectedApplication.status]}
              </Typography>
            </Typography>
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: '18px',
                letterSpacing: '0.4px',
                ml: { sm: 9 },
                mt: 1,
              }}>
              Rejected on:{' '}
              <Typography
                component="span"
                sx={{
                  color: '#337FC9',
                  fontSize: '16px',
                  letterSpacing: '0.4px',
                  ml: 0.5,
                }}>
                {formatShortDateAndTime(rejectedApplication.rejectedAt)}
              </Typography>
            </Typography>
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: '18px',
                letterSpacing: '0.4px',
                ml: { sm: 9.5 },
                mt: 1,
              }}>
              Rejected by:{' '}
              <Typography
                component="span"
                sx={{
                  color: '#337FC9',
                  fontSize: '16px',
                  letterSpacing: '0.4px',
                  ml: 0.5,
                }}>
                {REJECTED_ROLES[rejectedApplication.rejectedByRole]}
              </Typography>
            </Typography>
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: '18px',
                letterSpacing: '0.4px',
                mt: 1,
              }}>
              Reason for rejection:{' '}
              <Typography
                component="span"
                sx={{
                  color: '#337FC9',
                  fontSize: '16px',
                  letterSpacing: '0.4px',
                  ml: 0.5,
                }}>
                {rejectedApplication.rejectedReason}
              </Typography>
            </Typography>
            <Button
              variant="contained"
              sx={{ ml: '32%', lineHeight: 1.1, width: '30%', mt: 3 }}
              onClick={handleRejectionDialogClose}>
              Done
            </Button>
          </Box>
        )}
      </Dialog>
      <ConfirmationDialog
        message={'Are you sure you want to delete Application ?'}
        open={deletePopUp !== null}
        setOpen={() => setDeletePopUp(null)}
        onSave={async () => {
          try {
            setDeletePopUp(null);
            const _application = (await dispatch(
              getApplicationDetails(deletePopUp?.id || '', 'delete')
            )) as unknown as ApplicationProps;
            if (DashboardApplicationsList) {
              setDialogLoading(true);
              const response = (await dispatch(
                getAllApplications({
                  page: 1,
                  limit: 4,
                })
              )) as unknown as GetAllApplicantionsResponseBody;
              const { applications } = response || {};
              setApplicationsListData(applications);
              setDialogLoading(false);
            } else {
              setApplicationsListData(
                applicationsListData.filter(
                  (application) => application.id !== deletePopUp?.id || ''
                )
              );
            }
            enqueueSnackbar('Application Deleted Successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          } catch (e) {
            setDialogLoading(false);
            console.error((e as Error).message);
          }
        }}
        onCancel={() => setDeletePopUp(null)}
      />
    </>
  );
}
